import { createMuiStyles } from '../../utils/mui';
export const providerInfoStyles = createMuiStyles({
  wrapper: {
    width: '100%',
    display: 'block',
    textDecoration: 'none',
    color: 'common.black',
    '&.a': {
      border: 1,
      p: 3,
      borderRadius: '0.75rem',
      borderColor: 'grey.200',
      h6: {
        transition: '0.3s',
      },
      '&:hover': {
        h6: {
          color: 'primary.main',
        },
      },
    },
  },
  imgWrapper: {
    flex: { xs: 1, sm: 0 },
    position: 'relative',
    img: {
      width: { xs: '100%', sm: '15rem' },
      minHeight: '100%',
      height: '12.5rem',
      objectFit: 'contain',
      objectPosition: 'center',
      bgcolor: 'common.white',
      borderRadius: 2,
      border: (theme) => `1px solid ${theme.palette.grey[100]}`,
    },
  },
  viewGalleryBtn: {
    bgcolor: 'common.white',
    borderColor: 'grey.200',
    position: 'absolute',
    bottom: '1rem',
    right: '1rem',
    '&:hover,&:focus': {
      bgcolor: 'grey.50',
    },
  },
  mobileWishlistBtn: {
    position: 'absolute',
    right: 0,
    top: 0,
    mt: 5,
    mr: 3,
  },
  scholarshipBadge: {
    color: 'success.main',
    bgcolor: 'success.light',
    borderRadius: 2,
    py: { xs: 0.5, md: 1.5 },
    px: { xs: 1, md: 2.5 },
    textAlign: 'right',
    display: 'flex',
    gap: '0.25rem',
    alignItems: { xs: 'center', md: 'flex-end' },
    flexDirection: { xs: 'row', md: 'column' },
  },
  providerMapWrapper: {
    minWidth: '20rem',
    minHeight: '12.5rem',
    maxWidth: {
      md: '35rem!important',
    },
  },
  providerMap: {
    borderRadius: 2,
    bgcolor: 'grey.100',
    height: 1,
    width: 1,
    iframe: {
      border: 0,
      borderRadius: 'inherit',
    },
  },
});
